import React, { useEffect, useMemo, useState } from "react";
import Header from "./Header";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { postMethod } from "../core/service/common.api";
import apiService from "../core/service/detail";
import { useAuth } from "./AuthContext";
import Select from "react-select";
import countryList from "react-select-country-list";

const colourStyles = {
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isFocused ? "#24252a" : "#17171a",
    color: isFocused ? "#ffc630" : "#fff",
    cursor: isDisabled ? "not-allowed" : "pointer",
    borderBottom: `1px solid ${isFocused ? "#ffc630" : "#17171a"}`,
  }),
  menu: (styles) => ({
    ...styles,
    border: "1px solid #444",
    borderRadius: "4px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    backgroundColor: "transparent",
  }),
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: "transparent",
    borderColor: isFocused ? "#ffc630" : "#444",
    boxShadow: isFocused ? "0 0 0 1px #ffc630" : "none",
    "&:hover": {
      borderColor: isFocused ? "#ffc630" : "#555",
    },
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#888",
  }),
};

export default function Register() {
  const [currentStep, setCurrentStep] = useState(1);
  const [isReferralFromUrl, setIsReferralFromUrl] = useState(false);
  
  useEffect(() => {
    let str = window.location.href;
    const letters = str.includes("?");
    if (letters) {
      let locationData = window.location.href.split("=")[1];
      let formData = { ...formValue, ...{ referral_code: locationData } };
      setFormValue(formData);
      setIsReferralFromUrl(true);
    }
  }, []);

  const { register } = useAuth();
  const initialFormValue = {
    firstname: "",
    lastname: "",
    dob: "",
    country: "",
    countrycode: "",
    identityType: "",
    identityNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    referral_code: "",
    terms: false,
  };

  const [validationnErr, setvalidationnErr] = useState({});
  const [formValue, setFormValue] = useState(initialFormValue);
  const [buttonLoader, setbuttonLoader] = useState(false);
  const [passHide, setPasshide] = useState(false);
  const [inputType, setinputType] = useState("password");
  const [passHidconf, setPasshideconf] = useState(false);
  const [inputTypeconf, setinputTypeconf] = useState("password");
  const [touchedFields, setTouchedFields] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);

  const { firstname, lastname, dob, country, identityType, identityNumber, email, password, confirmPassword, referral_code, terms } = formValue;

  const navigate = useNavigate();
  const createUid = uuidv4();
  const createdUuid = createUid.split("-")[0].toString();

  const options = useMemo(() => countryList().getData(), []);

  const document_options = [
    { value: 'national-id', label: 'National ID' },
    { value: 'Passport', label: 'Passport' },
  ];

  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
    .toISOString()
    .split("T")[0];

  const handleChange = async (e) => {
    e.preventDefault();
    const { name, value, type, checked } = e.target;
    const fieldValue = type === 'checkbox' ? checked : value.replace(/\s/g, "");
    let formData = { ...formValue, ...{ [name]: fieldValue } };
    setFormValue(formData);
    
  
    if (touchedFields[name] || submitAttempted) {
      validateField(name, fieldValue);
    }
  };

  const handleBlur = (fieldName) => {
    setTouchedFields({ ...touchedFields, [fieldName]: true });
    validateField(fieldName, formValue[fieldName]);
  };

  const validateField = (fieldName, value) => {
    let errors = { ...validationnErr };
    
    switch (fieldName) {
      case 'email':
        const username = value ? value.split("@")[0] : "";
        if (!value) {
          errors.email = "Email is a required field!";
        } else if (
          !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(value)
        ) {
          errors.email = "Invalid email address!";
        } else if (!/^[a-zA-Z0-9.]+$/i.test(username)) {
          errors.email =
            "Only letters (a-z), numbers (0-9), and periods (.) are allowed in the username";
        } else if (!/[a-zA-Z]/.test(username)) {
          errors.email = "Email username must contain at least one letter (a-z)";
        } else {
          delete errors.email;
        }
        break;
        
      case 'password':
        if (!value) {
          errors.password = "Password is required!";
        } else if (value.length < 15 || value.length > 30) {
          errors.password = "Password should be between 15 and 30 characters!";
        } else if (!value.match(/[a-z]/)) {
          errors.password = "Please enter at least one lowercase character!";
        } else if (!value.match(/[A-Z]/)) {
          errors.password = "Please enter at least one uppercase character!";
        } else if (!value.match(/[0-9]/)) {
          errors.password = "Please enter at least one digit!";
        } else if (!value.match(/[!@#$%^&*]/)) {
          errors.password = "Please enter at least one special character!";
        } else {
          delete errors.password;
        }
        break;
        
      case 'confirmPassword':
        if (!value) {
          errors.confirmPassword = "Confirm password is required!";
        } else if (formValue.password !== value) {
          errors.confirmPassword = "Password and confirm password do not match!";
        } else {
          delete errors.confirmPassword;
        }
        break;
        
      case 'firstname':
        if (!value || value.trim() === "") {
          errors.firstname = "First name is required!";
        } else if (!/^[a-zA-Z]+$/i.test(value)) {
          errors.firstname = "First name should contain only letters!";
        } else if (value.length < 2) {
          errors.firstname = "First name must be at least 2 characters!";
        } else if (value.length > 30) {
          errors.firstname = "First name must be less than 30 characters!";
        } else {
          delete errors.firstname;
        }
        break;
        
      case 'lastname':
        if (!value || value.trim() === "") {
          errors.lastname = "Last name is required!";
        } else if (!/^[a-zA-Z]+$/i.test(value)) {
          errors.lastname = "Last name should contain only letters!";
        } else if (value.length < 1) {
          errors.lastname = "Last name must be at least 1 character!";
        } else if (value.length > 30) {
          errors.lastname = "Last name must be less than 30 characters!";
        } else {
          delete errors.lastname;
        }
        break;
        
      case 'dob':
        if (!value) {
          errors.dob = "Date of birth is required!";
        } else {
          const today = new Date();
          const dob = new Date(value);
          let age = today.getFullYear() - dob.getFullYear();
          const monthDiff = today.getMonth() - dob.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
          }

          if (age < 18) {
            errors.dob = "You must be at least 18 years old!";
          } else {
            delete errors.dob;
          }
        }
        break;
        
      case 'country':
        if (!value) {
          errors.country = "Country is required!";
        } else {
          delete errors.country;
        }
        break;
        
      case 'identityType':
        if (!value) {
          errors.identityType = "Identity type is required!";
        } else {
          delete errors.identityType;
        }
        break;
        
      case 'identityNumber':
        if (!value || value.trim() === "") {
          errors.identityNumber = "Identity number is required!";
        } else if (!/^[a-zA-Z0-9]+$/i.test(value)) {
          errors.identityNumber = "Identity number should contain only letters and numbers!";
        } else {
          delete errors.identityNumber;
        }
        break;
        
      case 'terms':
        if (!value) {
          errors.terms = "You must accept the terms!";
        } else {
          delete errors.terms;
        }
        break;
        
      default:
        break;
    }
    
    setvalidationnErr(errors);
    return errors;
  };

  const validateStep = (step, values) => {
    let errors = {};
    
    if (step === 1) {
      
      const username = values.email ? values.email.split("@")[0] : "";
      if (!values.email) {
        errors.email = "Email is a required field!";
      } else if (
        !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(values.email)
      ) {
        errors.email = "Invalid email address!";
      } else if (!/^[a-zA-Z0-9.]+$/i.test(username)) {
        errors.email =
          "Only letters (a-z), numbers (0-9), and periods (.) are allowed in the username";
      } else if (!/[a-zA-Z]/.test(username)) {
        errors.email = "Email username must contain at least one letter (a-z)";
      }

      
      if (!values.password) {
        errors.password = "Password is required!";
      } else if (values.password.length < 15 || values.password.length > 30) {
        errors.password = "Password should be between 15 and 30 characters!";
      } else if (!values.password.match(/[a-z]/)) {
        errors.password = "Please enter at least one lowercase character!";
      } else if (!values.password.match(/[A-Z]/)) {
        errors.password = "Please enter at least one uppercase character!";
      } else if (!values.password.match(/[0-9]/)) {
        errors.password = "Please enter at least one digit!";
      } else if (!values.password.match(/[!@#$%^&*]/)) {
        errors.password = "Please enter at least one special character!";
      }

   
      if (!values.confirmPassword) {
        errors.confirmPassword = "Confirm password is required!";
      } else if (values.password !== values.confirmPassword) {
        errors.confirmPassword = "Password and confirm password do not match!";
      }
    } else if (step === 2) {
      
      if (!values.firstname || values.firstname.trim() === "") {
        errors.firstname = "First name is required!";
      } else if (!/^[a-zA-Z]+$/i.test(values.firstname)) {
        errors.firstname = "First name should contain only letters!";
      } else if (values.firstname.length < 2) {
        errors.firstname = "First name must be at least 2 characters!";
      } else if (values.firstname.length > 30) {
        errors.firstname = "First name must be less than 30 characters!";
      }

     
      if (!values.lastname || values.lastname.trim() === "") {
        errors.lastname = "Last name is required!";
      } else if (!/^[a-zA-Z]+$/i.test(values.lastname)) {
        errors.lastname = "Last name should contain only letters!";
      } else if (values.lastname.length < 1) {
        errors.lastname = "Last name must be at least 1 character!";
      } else if (values.lastname.length > 30) {
        errors.lastname = "Last name must be less than 30 characters!";
      }

      
      if (!values.dob) {
        errors.dob = "Date of birth is required!";
      } else {
        const today = new Date();
        const dob = new Date(values.dob);
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
          age--;
        }

        if (age < 18) {
          errors.dob = "You must be at least 18 years old!";
        }
      }

   
      if (!values.country) {
        errors.country = "Country is required!";
      }

     
      if (!values.identityType) {
        errors.identityType = "Identity type is required!";
      }


      if (!values.identityNumber || values.identityNumber.trim() === "") {
        errors.identityNumber = "Identity number is required!";
      } else if (!/^[a-zA-Z0-9]+$/i.test(values.identityNumber)) {
        errors.identityNumber = "Identity number should contain only letters and numbers!";
      }

 
      if (!values.terms) {
        errors.terms = "You must accept the terms!";
      }
    }

    setvalidationnErr(errors);
    return errors;
  };

  const nextStep = () => {
    const errors = validateStep(currentStep, formValue);
    if (Object.keys(errors).length === 0) {
      setCurrentStep(currentStep + 1);
    } else {
     
      const stepFields = currentStep === 1 
        ? ['email', 'password', 'confirmPassword'] 
        : ['firstname', 'lastname', 'dob', 'country', 'identityType', 'identityNumber', 'terms'];
      
      const newTouched = { ...touchedFields };
      stepFields.forEach(field => {
        newTouched[field] = true;
      });
      setTouchedFields(newTouched);
    }
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const passwordHide = (data) => {
    if (data == "hide") {
      setPasshide(true);
      setinputType("text");
    } else {
      setPasshide(false);
      setinputType("password");
    }
  };

  const passwordHideconf = (data) => {
    if (data == "hide") {
      setPasshideconf(true);
      setinputTypeconf("text");
    } else {
      setPasshideconf(false);
      setinputTypeconf("password");
    }
  };

  const formSubmit = async () => {
    setSubmitAttempted(true);
    
   
    const allFields = ['email', 'password', 'confirmPassword', 'firstname', 'lastname', 
                      'dob', 'country', 'identityType', 'identityNumber', 'terms'];
    const newTouched = { ...touchedFields };
    allFields.forEach(field => {
      newTouched[field] = true;
    });
    setTouchedFields(newTouched);
    

    const step1Errors = validateStep(1, formValue);
    const step2Errors = validateStep(2, formValue);
    const allErrors = { ...step1Errors, ...step2Errors };
    
    if (Object.keys(allErrors).length === 0) {
      formValue["UUID"] = createdUuid;
      var data = {
        apiUrl: apiService.signup,
        payload: formValue,
      };
      setbuttonLoader(true);
      var resp = await postMethod(data);
      setbuttonLoader(false);
      if (resp.status == true) {
        toast.success(resp.Message);
        sessionStorage.setItem("useremail", formValue.email);
        navigate("/verification");
      } else {
        toast.error(resp.Message);
      }
    } else {
     
      const firstErrorField = Object.keys(allErrors)[0];
      const element = document.querySelector(`[name="${firstErrorField}"]`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        
        const firstErrorElement = document.getElementById(firstErrorField);
        if (firstErrorElement) {
          firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  };

  const handleCountryChange = (option) => {                                                       
    const updatedFormValue = {
      ...formValue,
      country: option ? option.label : "",
      countrycode: option ? option.value : ""
    };

    setFormValue(updatedFormValue);
    
    
    if (touchedFields.country || submitAttempted) {
      validateField('country', option ? option.label : "");
    }
  };

  const handleDocumentChange = (option) => {
    const updatedFormValue = {
      ...formValue,
      identityType: option ? option.label : "",
    };
    setFormValue(updatedFormValue);
    
 
    if (touchedFields.identityType || submitAttempted) {
      validateField('identityType', option ? option.label : "");
    }
  };


  const shouldShowError = (fieldName) => {
    return (touchedFields[fieldName] || submitAttempted) && validationnErr[fieldName];
  };

  return (
    <>
      <main className="fidex_landing_main">
        <section>
          <Header />
        </section>
      </main>

      <div>
        <div className="register">
          <div className="container">
            <div className="row reg-container">
              <div className="col-lg-6 left-reg ">
                <div className="reg-left-flex">
                  <div className="reg-left-title">
                    Sign Up and Start Earning Rewards on Every Trade!
                  </div>
                  <div className="reg-gift">
                    <img
                      src={require("../assets/reg-gift.webp")}
                      alt="gift-icon"
                    />
                  </div>
                  <div className="reg-left-content">
                    Join now to earn rewards, access top tools, and boost your
                    trading potential. Start today!
                  </div>
                </div>
              </div>

              <div className="col-lg-6 right-reg">
                <span className="heading">Welcome To Voltrix Crypt</span>
                
               
                
               
                {currentStep === 1 && (
                  <div className="step-content">
                    <div className="input-groups mt-4 mb-3">
                      <h6 className="input-label mb-3">Email</h6>
                      <input
                        type="text"
                        name="email"
                        value={email}
                        maxLength="250"
                        onChange={handleChange}
                        onBlur={() => handleBlur('email')}
                        className="input-field"
                        placeholder="Please enter your email address"
                      />
                      {shouldShowError('email') && (
                        <p className="errorcss">{validationnErr.email}</p>
                      )}
                    </div>

                    <div className="input-groups icons my-4">
                      <h6 className="input-label mb-3">Password</h6>
                      <div className="flex_input_posion">
                        <input
                          type={inputType}
                          name="password"
                          value={password}
                          minLength="15"
                          maxLength="30"
                          onChange={handleChange}
                          onBlur={() => handleBlur('password')}
                          className="input-field"
                          placeholder="Please create a password"
                        />
                        {passHide == true ? (
                          <i
                            className="fa-regular fa-eye reg_eye"
                            onClick={() => passwordHide("show")}
                          ></i>
                        ) : (
                          <i
                            className="fa-regular fa-eye-slash reg_eye"
                            onClick={() => passwordHide("hide")}
                          ></i>
                        )}
                      </div>
                      {shouldShowError('password') && (
                        <p className="errorcss">{validationnErr.password}</p>
                      )}
                    </div>

                    <div className="input-groups icons my-4">
                      <h6 className="input-label mb-3">Confirm Password</h6>
                      <div className="flex_input_posion">
                        <input
                          type={inputTypeconf}
                          name="confirmPassword"
                          value={confirmPassword}
                          minLength="15"
                          maxLength="30"
                          onChange={handleChange}
                          onBlur={() => handleBlur('confirmPassword')}
                          className="input-field"
                          placeholder="Please re-enter the password"
                        />
                        {passHidconf == true ? (
                          <i
                            className="fa-regular fa-eye reg_eye"
                            onClick={() => passwordHideconf("show")}
                          ></i>
                        ) : (
                          <i
                            className="fa-regular fa-eye-slash reg_eye"
                            onClick={() => passwordHideconf("hide")}
                          ></i>
                        )}
                      </div>
                      {shouldShowError('confirmPassword') && (
                        <p className="errorcss">{validationnErr.confirmPassword}</p>
                      )}
                    </div>

                    <div className="input-groups icons">
                      <h6 className="input-label mb-3">Refferal code</h6>
                      <input
                        type="text"
                        name="referral_code"
                        maxLength="11"
                        value={referral_code}
                        disabled={isReferralFromUrl}
                        onChange={handleChange}
                        className="input-field"
                        placeholder="Refferal code ( Optional )"
                      />
                    </div>

                    <div className="step-navigation step2-nav">
                      <button className="back-btns" disabled >
                       Go Back
                      </button>
                      <button className="next-btn" onClick={nextStep}>
                        Next
                      </button>
                    </div>
                  </div>
                )}

             
                {currentStep === 2 && (
                  <div className="step-content">
                    <div className="input-groups mt-4 mb-3">
                      <h6 className="input-label mb-3">First Name</h6>
                      <input
                        type="text"
                        name="firstname"
                        value={firstname}
                        maxLength="250"
                        onChange={handleChange}
                        onBlur={() => handleBlur('firstname')}
                        className="input-field"
                        placeholder="Please enter your first name"
                      />
                      {shouldShowError('firstname') && (
                        <p className="errorcss">{validationnErr.firstname}</p>
                      )}
                    </div>

                    <div className="input-groups mt-4 mb-3">
                      <h6 className="input-label mb-3">Last Name</h6>
                      <input
                        type="text"
                        name="lastname"
                        value={lastname}
                        maxLength="250"
                        onChange={handleChange}
                        onBlur={() => handleBlur('lastname')}
                        className="input-field"
                        placeholder="Please enter your last name"
                      />
                      {shouldShowError('lastname') && (
                        <p className="errorcss">{validationnErr.lastname}</p>
                      )}
                    </div>

                    <div className="input-groups mt-4 mb-3">
                      <h6 className="input-label mb-3">Date Of Birth</h6>
                      <input
                        type="date"
                        name="dob"
                        value={dob}
                        onChange={handleChange}
                        onBlur={() => handleBlur('dob')}
                        max={maxDate}
                        className="input-field"
                        placeholder="Please enter your date of birth"
                      />
                      {shouldShowError('dob') && (
                        <p className="errorcss">{validationnErr.dob}</p>
                      )}
                    </div>

                    <div className="input-groups mt-4 mb-3" id="country">
                      <h6 className="input-label mb-3">Country</h6>
                      <Select
                        options={options}
                        value={options.find(
                          (option) => option.label === country
                        )}
                        onChange={handleCountryChange}
                        onBlur={() => handleBlur('country')}
                        placeholder="Select Country"
                        className="kyc_nation nw_lgn_slct"
                        styles={colourStyles}
                      />
                      {shouldShowError('country') && (
                        <p className="errorcss">{validationnErr.country}</p>
                      )}
                    </div>

                    <div className="input-groups mt-4 mb-3" id="identityType">
                      <h6 className="input-label mb-3">Select Identification Type</h6>
                      <Select
                        options={document_options}
                        value={document_options.find(
                          (option) => option.label === identityType
                        )}
                        onChange={handleDocumentChange}
                        onBlur={() => handleBlur('identityType')}
                        placeholder="Select Type"
                        className="kyc_nation nw_lgn_slct"
                        styles={colourStyles}
                      />
                      {shouldShowError('identityType') && (
                        <p className="errorcss">{validationnErr.identityType}</p>
                      )}
                    </div>

                    <div className="input-groups mt-4 mb-3">
                      <h6 className="input-label mb-3">Identity Document Number</h6>
                      <input
                        type="text"
                        name="identityNumber"
                        value={identityNumber}
                        maxLength="250"
                        onChange={handleChange}
                        onBlur={() => handleBlur('identityNumber')}
                        className="input-field"
                        placeholder="Please enter your identity number"
                      />
                      {shouldShowError('identityNumber') && (
                        <p className="errorcss">{validationnErr.identityNumber}</p>
                      )}
                    </div>

                    <div className="terms-new">
                      <div className="terms">
                        <div className="checkbox-container">
                          <input
                            id="custom-checkbox"
                            name="terms"
                            checked={terms}
                            onChange={handleChange}
                            onBlur={() => handleBlur('terms')}
                            className="input-field regular_checkbox"
                            type="checkbox"
                            placeholder="Enter the referral ID (optional)"
                          />
                          <label htmlFor="custom-checkbox"></label>
                        </div>

                        <label htmlFor="custom-checkbox" className="terms-check">
                          I have read and agree to the
                          <Link to="/terms" className="text-yellow" target="_blank">
                            {" "}
                            Terms & Conditions{" "}
                          </Link>{" "}
                          and{" "}
                          <Link
                            to="/privacy"
                            className="text-yellow"
                            target="_blank"
                          >
                            {" "}
                            Privacy Policy
                          </Link>
                        </label>
                      </div>

                      {shouldShowError('terms') && (
                        <p className="errorcss">
                          {validationnErr.terms}
                        </p>
                      )}
                    </div>

                    <div className="step-navigation step2-nav">
                      <button className="back-btn" onClick={prevStep}>
                       Go Back
                      </button>
                      <div className="Submit">
                        {buttonLoader == false ? (
                          <button onClick={formSubmit}>Register</button>
                        ) : (
                          <button>Loading ...</button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="foot">
                  <p>
                    Already registered ? <Link to="/login">Login</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .step-indicator {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #ddd;
        }
        
        .step-indicator.active {
          background: #ffc630;
          transform: scale(1.2);
        }
        
        .step-navigation {
          display: flex;
          margin-top: 30px;
        }
        
        .step1-nav {
          justify-content: flex-end;
        }
        
        .step2-nav {
          justify-content: space-between;
        }
        
        .back-btn,.back-btns, .next-btn, .Submit button {
          padding: 12px 25px;
          border: none;
          border-radius: 25px;
          cursor: pointer;
          font-weight: bold;
          font-family: 'Satoshi', sans-serif;
          transition: all 0.3s ease;
          min-width: 200px;
          text-align: center;
          font-size: 14px;
          box-sizing: border-box;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .back-btn {
          background: #ffc630;
          color: #000;
         
        }
        .back-btns {
          background: #ffc630;
          color: #000;
          cursor: not-allowed;
        }
        
        .back-btn:hover {
          background: #ffc630;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        
        .next-btn, .Submit button {
          background: #ffc630;
          color: #000;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        .next-btn:hover, .Submit button:hover {
          background: #ffc630;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }
        
        .next-btn:active, .back-btn:active, .back-btns:active,  .Submit button:active {
          transform: translateY(0);
        }
        
        .step-content {
          animation: fadeIn 0.3s ease-in;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .Submit button[disabled] {
          opacity: 0.8;
          cursor: not-allowed;
        }

        .input-field, .kyc_nation > div {
          height: 44px;
          padding: 10px 15px;
          border-radius: 4px;
          border: 1px solid #444;
          background-color: transparent;
          color: #fff;
          font-size: 14px;
          width: 100%;
          box-sizing: border-box;
        }

         .input-field, .kyc_nation.nw_lgn_slct > div{
         padding:0px;
         }
        
        .kyc_nation {
          width: 100%;
        }
        
        .kyc_nation > div {
          border-radius: 4px;
        }
        
        .input-field:focus, .kyc_nation > div:focus-within {
          border-color: #ffc630;
          outline: none;
          box-shadow: 0 0 0 1px #ffc630;
        }
        
        .errorcss {
          color: #ff4d4f;
          font-size: 12px;
          margin-top: 5px;
        }
      `}</style>
    </>
  );
}